'use client';

import { Time } from '@internationalized/date';
import type { TimeValue } from 'react-aria-components';

export const ensureArray = <T>(value: T): string[] => {
  if (value === undefined) {
    return [];
  }

  return Array.isArray(value) ? value : [value as string];
};

export const toTimeValue = (value?: string) => {
  if (!value) {
    return undefined;
  }
  const date = new Date(value);
  return new Time(
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
  ) as unknown as TimeValue;
};
export const removeUndefinedValues = <T>(obj: Partial<T>) => {
  const result: Partial<T> = {};
  Object.keys(obj).forEach((key) => {
    const value = obj[key as keyof T];
    if (value) {
      result[key as keyof T] = value;
    }
  });
  return result;
};

export const capitalize = (text: string) => {
  const words = text.split(' ');
  const capitalizedWords = words.map((word) => {
    if (word.length > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }
    return '';
  });

  return capitalizedWords.join(' ');
};
